import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconSend: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 12"
      fill="none"
      className={className}
    >
      <path
        d="M1.97339 11.6027C1.72172 11.7033 1.4829 11.6819 1.25693 11.5385C1.03095 11.3952 0.917969 11.1865 0.917969 10.9123V7.39458L6.68714 6.00042L0.917969 4.60625V1.08854C0.917969 0.814376 1.03095 0.605626 1.25693 0.462292C1.4829 0.318959 1.72172 0.297571 1.97339 0.398127L13.6038 5.30167C13.9137 5.44042 14.0686 5.67382 14.0686 6.00188C14.0686 6.32993 13.9137 6.56236 13.6038 6.69917L1.97339 11.6027Z"
        fill={color}
      />
    </svg>
  );
};

export default IconSend;
